import React from 'react'
import { List } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(() => ({
  root: ({ loading }) => ({
    listStyle: 'disc inside',
    '&.MuiList-padding': {
      paddingTop: 0,
      paddingBottom: 0
    },
    '& li': {
      ...(!loading && { display: 'list-item' }),
      paddingBottom: 0
    }
  })
}))

const BulletList = ({ children, ...props }) => {
  const classes = useStyles(props)
  const { loading, ...rest } = props
  return (
    <List className={classes.root} {...rest}>
      {children}
    </List>
  )
}

export default BulletList
